import Vue from "vue";
import Router from "vue-router";
import { clearStructuredData, setSeo } from "./utils/seo";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
      meta: {
        title: "精装入场查验与工程质量过程管控｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测有限公司面向开发商、建设单位、物业单位和住宅交付项目，提供精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测服务。"
      }
    },
    {
      path: "/services",
      name: "services",
      component: () => import("./views/ServiceCenter.vue"),
      meta: {
        title: "对公工程查验服务｜精装入场查验｜过程质量巡检｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测有限公司对公工程查验服务面向开发商、建设单位、物业单位和住宅交付项目，覆盖精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测。"
      }
    },
    {
      path: "/owner-inspection",
      name: "owner-inspection",
      component: () => import("./views/OwnerInspection.vue"),
      meta: {
        title: "业主验房与收房陪验服务｜新房验房｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测有限公司提供业主验房、新房验房、精装修验房、毛坯房验房和收房陪验服务，面向江苏、上海及长三角个人业主，协助记录房屋质量问题和整改建议。"
      }
    },
    {
      path: "/services/jingzhuangfang-check",
      redirect: "/services/jingzhuang-entry-inspection"
    },
    {
      path: "/services/maopeifang-check",
      redirect: "/services/process-quality-patrol"
    },
    {
      path: "/services/shice-shiliang",
      redirect: "/services/household-inspection"
    },
    {
      path: "/services/project-delivery-check",
      redirect: "/services/pre-delivery-acceptance"
    },
    {
      path: "/services/:slug",
      name: "service-detail",
      component: () => import("./views/ServiceDetail.vue"),
      meta: {
        title: "对公工程查验服务详情｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测有限公司对公工程查验服务详情，介绍精装入场查验、过程质量巡检、分户查验、交付前预验收、整改复查和工程质量检测的适用对象、服务场景、流程与交付成果。"
      }
    },
    {
      path: "/knowledge",
      name: "knowledge",
      component: () => import("./views/News.vue"),
      meta: {
        title: "工程检测知识库｜精装入场查验与交付质量管理指南｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测知识库，聚焦精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、工程质量检测、检测报告和整改复查。"
      }
    },
    {
      path: "/knowledge/:id",
      name: "knowledge-detail",
      component: () => import("./views/NewsDetails.vue"),
      meta: {
        title: "工程检测知识文章｜精装入场查验与整改复查｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测知识文章，提供精装入场查验、过程质量巡检、分户查验、工程质量检测、住宅交付质量管理和整改复查相关专业说明。"
      }
    },
    {
      path: "/news",
      redirect: "/knowledge"
    },
    {
      path: "/newsdetails/:id",
      redirect: to => "/knowledge/" + to.params.id
    },
    {
      path: "/cases",
      name: "public-cases",
      component: () => import("./views/Case.vue"),
      meta: {
        title: "对公工程查验服务案例｜过程质量管控与整改复查｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测有限公司案例中心展示精装入场查验、过程质量巡检、分户查验、交付前预验收、工程质量检测和整改复查项目的服务内容与交付成果。"
      }
    },
    {
      path: "/cases/:id",
      name: "case-detail",
      component: () => import("./views/CaseDetails.vue"),
      meta: {
        title: "对公工程查验案例详情｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测案例详情，展示对公工程查验项目城市、项目类型、服务内容、检测范围、交付成果和项目价值。"
      }
    },
    {
      path: "/case",
      redirect: "/cases"
    },
    {
      path: "/casedetails/:id",
      redirect: to => "/cases/" + to.params.id
    },
    {
      path: "/product",
      redirect: "/services"
    },
    {
      path: "/honor",
      name: "honor",
      component: () => import("./views/Honor.vue"),
      meta: {
        title: "资质荣誉与报告样张｜江苏道鼎升工程检测",
        description:
          "江苏道鼎升工程检测资质与信任信息，展示质量管理体系、对公工程查验服务能力、标准化报告输出和长三角项目服务经验。"
      }
    },
    {
      path: "/goin",
      name: "goin",
      component: () => import("./views/GoIn.vue"),
      meta: {
        title: "关于江苏道鼎升工程检测有限公司｜对公工程查验与质量过程管控",
        description:
          "江苏道鼎升工程检测有限公司面向开发商、建设单位、物业单位和住宅交付项目，提供精装入场查验、过程质量巡检、分户查验、交付前预验收、工程质量检测和整改复查服务。"
      }
    },
    {
      path: "/download",
      name: "download",
      component: () => import("./views/Download.vue"),
      meta: {
        title: "联系江苏道鼎升工程检测有限公司｜获取对公项目查验方案",
        description:
          "联系江苏道鼎升工程检测有限公司，获取精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、工程质量检测和整改复查项目方案。"
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        title: "管理登录｜江苏道鼎升工程检测"
      }
    },
    {
      path: "/admin",
      name: "admin",
      meta: {
        requireAuth: true,
        title: "管理后台｜江苏道鼎升工程检测"
      },
      component: () => import("./views/Admin.vue"),
      children: [
        {
          path: "/admin/user",
          name: "user",
          component: () => import("./views/Admin/User.vue")
        },
        {
          path: "/admin/news",
          name: "new",
          component: () => import("./views/Admin/News.vue")
        },
        {
          path: "/admin/cases",
          name: "cases",
          component: () => import("./views/Admin/Cases.vue")
        },
        {
          path: "/admin/team",
          name: "team",
          component: () => import("./views/Admin/Team.vue")
        },
        {
          path: "/admin/course",
          name: "course",
          component: () => import("./views/Admin/Course.vue")
        },
        {
          path: "/admin/enterprise",
          name: "enterprise",
          component: () => import("./views/Admin/Enterprise.vue")
        },
        {
          path: "/admin/honor",
          name: "admin-honor",
          component: () => import("./views/Admin/Honor.vue")
        },
        {
          path: "/admin/dictionary",
          name: "dictionary",
          component: () => import("./views/Admin/Dictionary.vue")
        },
        {
          path: "/admin/page",
          name: "page",
          component: () => import("./views/Admin/Page.vue")
        }
      ]
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/NotFound.vue"),
      meta: {
        title: "页面未找到｜江苏道鼎升工程检测",
        description: "页面未找到。返回江苏道鼎升工程检测有限公司首页，了解精装入场查验、过程质量巡检、分户查验、一房一验、工程质量检测和整改复查服务。"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  clearStructuredData();

  if (to.matched.some(record => record.meta.requireAuth)) {
    if (sessionStorage.getItem("token")) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

router.afterEach(to => {
  setSeo({
    title: to.meta.title,
    description: to.meta.description,
    path: to.path
  });
});

export default router;
